import { getGameFreespin } from '../api/getGamesFreespin';
import { setGetGamesListFsAction } from '../action';

const setGetGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGameFreespin(params);

            if (data.status === 'success') {
                dispatch(setGetGamesListFsAction(data.data))
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetGameFreespin
}